// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"3b53517f","6587":"77ab36e7"}[chunkId] + ".chunk.css";
};